const has = Object.prototype.hasOwnProperty

function decode(input) {
    try {
        return decodeURIComponent(input.replaceAll('+', ' ')) ?? undefined
    } catch {
        return
    }
}

function encode(input) {
    try {
        return encodeURIComponent(input) ?? undefined
    } catch {
        return
    }
}

function qsParse(query) {
    const parser = /([^#&=?]+)=?([^&]*)/g
    const result = {}
    let part

    while ((part = parser.exec(query))) {
        const key = decode(part[1])
        const value = decode(part[2])
        if (key === undefined || value === undefined || key in result) continue
        result[key] = value
    }

    return result
}

function qsStringify(object, prefix = '') {
    const pairs = []
    let value
    let key

    if ('string' !== typeof prefix) prefix = '?'

    for (key in object) {
        if (has.call(object, key)) {
            value = object[key]

            if (!value && (value === undefined || value === null || Number.isNaN(value))) {
                value = ''
            }

            key = encode(key)
            value = encode(value)

            if (key === undefined || value === undefined) continue
            pairs.push(key + '=' + value)
        }
    }

    return pairs.length > 0 ? prefix + pairs.join('&') : ''
}

export { qsParse, qsStringify }
